









import {Component, Vue, Watch} from 'vue-property-decorator';

import {AsixModule} from '@/store/modules/asix';

import TextBubble from '@/components/speechBubbles/TextBubble.vue';
import LinkBubble from '@/components/speechBubbles/LinkBubble.vue';
import ListBubble from '@/components/speechBubbles/ListBubble.vue';
import {Conversation, FormType, Output} from '@/types/asix';
import {BubbleType} from '@/types/timeline';

@Component({
  components: {
    TextBubble,
    ListBubble,
    LinkBubble,
  },
})
export default class Timeline extends Vue {
  public asixStore = AsixModule;
  public blankHeight: number = 0;
  public blankMarginTop = 12

  get blankStyle(): any {
    return {
      height: `${this.blankHeight}px`,
    }
  }

  get conversations(): Conversation[] {
    return this.asixStore.conversations
  }

  get latestConv(): Conversation | null {
    return this.asixStore.latestBotConv
  }

  get bubbleType() {
    return BubbleType
  }

  get headerHeight(): number {
    const header = document.getElementById('header')
    return header ? header.offsetHeight : 0
  }

  get chatFormHeight(): number {
    const chatForm = document.getElementById('chat-form')
    return chatForm ? chatForm.offsetHeight : 0
  }

  get latestConvHeight(): number {
    const convHeight = this.latestConv ? document.getElementById(String(this.latestConv.id)) : null
    return convHeight ? convHeight.offsetHeight : 0
  }

  public setBlankStyle() {
    // 余白の大きさ = フォームの高さ
    if (this.chatFormHeight) {
      this.blankHeight = this.chatFormHeight
    }
    return 0
  }

  public detectType(conv: Conversation): BubbleType {
    let bubbleType = BubbleType.Text
    if (conv.outList.some((o: Output) => o.expression_form === FormType.Link)) {
      bubbleType = BubbleType.Link
    }
    if (conv.outList.some((o: Output) => o.expression_form === FormType.Button)) {
      bubbleType = BubbleType.List
    }
    return bubbleType
  }

  public scrollToBottom() {
    this.$el.scrollTop = this.$el.scrollHeight
  }

  @Watch('latestConv')
  public onNewConversation(newConv: Conversation | null, oldConv: Conversation | null) {
    if (newConv) {
      this.$nextTick(() => {
        this.setBlankStyle()
        this.$nextTick(() => {
          document.getElementById(String(newConv.id))!.querySelectorAll<HTMLElement>('.focus-item').item(0).focus()
          this.scrollToBottom()
        })
      })
    }
  }
}
